if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.addToCartText = this.dataset.addToCartText || window.variantStrings.addToCart;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.addToCartText;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// HM Moab retreat stale-cache fallback, 2026-06-24.
(() => {
  const handle = '/products/holy-mountain-autumn-equinox-experience-retreat-moab-sept-2026';
  if (!window.location.pathname.includes(handle)) return;

  const productUrl = `${handle}?variant=48356461248766&utm_source=site&utm_medium=announcement&utm_content=moab_retreat`;
  const desiredMediaOrder = [
    '01_file_459',
    '04_file_462',
    '03_file_461',
    '09_file_467',
    '4e13e948',
    'cc16658c',
    '7fc62ada',
    '02_file_460',
    'a437dd46',
    '08_file_466',
    '413a6f1c',
    '558f2b48',
    '746d711f'
  ];

  function mediaRank(element) {
    const html = element.innerHTML || '';
    const idx = desiredMediaOrder.findIndex((needle) => html.includes(needle));
    return idx === -1 ? 999 : idx;
  }

  function sortMediaList(selector) {
    document.querySelectorAll(selector).forEach((list) => {
      const items = Array.from(list.children);
      if (items.length < 2) return;
      const sorted = [...items].sort((a, b) => mediaRank(a) - mediaRank(b));
      if (sorted.every((item, index) => item === items[index])) return;
      sorted.forEach((item) => list.appendChild(item));
    });
  }

  function fixAnnouncement() {
    const links = Array.from(document.querySelectorAll('.announcement-bar__link'));
    const messages = [
      'Moab Autumn Equinox Retreat — Sept. 26-Oct. 1. $300 deposit reserves your spot.',
      'Questions about travel, payment plans, or whether this is a fit? Text us directly.'
    ];
    links.forEach((link, index) => {
      const span = link.querySelector('.announcement-bar__message span');
      if (!span) return;
      const text = span.textContent || '';
      if (
        text.includes('Founding cohort pricing ends April 9') ||
        text.includes('Direct product orders currently paused') ||
        text.includes('Wholesale inquiries now open') ||
        text.includes('Moab Autumn Equinox Retreat')
      ) {
        span.textContent = messages[index % messages.length];
        link.setAttribute('href', productUrl);
      }
    });
  }

  function fixCopyAndMedia() {
    document.querySelectorAll('a, p, div, span').forEach((node) => {
      if ((node.textContent || '').trim() === 'Shipping calculated at checkout.') {
        const container = node.closest('.product__tax, .product__taxes, .product__shipping, p, div') || node;
        container.style.display = 'none';
        container.setAttribute('aria-hidden', 'true');
      }
    });

    document.querySelectorAll('h2').forEach((h2) => {
      if (h2.textContent.trim() === 'Opening Caption') {
        const next = h2.nextElementSibling;
        h2.remove();
        if (next && next.textContent.trim() === 'Sacred time in sacred space.') {
          next.innerHTML = '<strong>Not a retreat from the world. A return to the work.</strong>';
        }
      }
    });
    document.querySelectorAll('p, h2').forEach((node) => {
      if (node.textContent.trim() === 'Sacred time in sacred space.') {
        node.innerHTML = '<strong>Not a retreat from the world. A return to the work.</strong>';
      }
    });

    const fastPath = document.querySelector('.hm-retreat-fast-path');
    const lookbook = document.querySelector('.hm-retreat-lookbook-embed');
    if (fastPath && lookbook && lookbook.compareDocumentPosition(fastPath) & Node.DOCUMENT_POSITION_FOLLOWING) {
      lookbook.parentNode.insertBefore(fastPath, lookbook);
    }

    if (fastPath && !document.querySelector('.hm-retreat-video-proof')) {
      const video = document.createElement('div');
      video.className = 'hm-retreat-video-proof';
      video.style.margin = '22px 0 26px';
      video.innerHTML = `
        <h2>Watch Past Guests Talk About the Retreat</h2>
        <div style="position:relative;width:100%;height:0;padding-top:56.25%;background:#111;overflow:hidden;">
          <iframe src="https://www.youtube.com/embed/7f-ZkzQ6fa4" title="Autumn Equinox Experience Retreat: Past Guests in Their Own Words" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"></iframe>
        </div>`;
      fastPath.insertAdjacentElement('afterend', video);
    }
  }

  function applyFallback() {
    fixAnnouncement();
    fixCopyAndMedia();
    sortMediaList('media-gallery ul.product__media-list');
    sortMediaList('media-gallery .thumbnail-list');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFallback, { once: true });
  } else {
    applyFallback();
  }
  window.addEventListener('load', applyFallback, { once: true });
  setTimeout(applyFallback, 500);
  setTimeout(applyFallback, 1500);
})();

